import { TokenHistoryLabel } from "kadow-jetpack-model";

export function isAcquisitionCTA(label: TokenHistoryLabel) {
    switch (label) {
        case TokenHistoryLabel.Share:
        case TokenHistoryLabel.Receipt:
        case TokenHistoryLabel.BAO:
        case TokenHistoryLabel.CheckIn:
            return true;
        default:
            return false;
    }
}